import { createActionCreator } from 'deox';
import {
  TUpdateLicenseEmployeeBody,
  TUpdateLicenseEmployeeResponse,
} from '@/services/api/employee/update-employee-license';

// CONSTANTS

export enum EUpdateLicenseEmployeeAction {
  UPDATE_LICENSE_EMPLOYEE = 'UPDATE_LICENSE_EMPLOYEE',
  UPDATE_LICENSE_EMPLOYEE_REQUEST = 'UPDATE_LICENSE_EMPLOYEE_REQUEST',
  UPDATE_LICENSE_EMPLOYEE_SUCCESS = 'UPDATE_LICENSE_EMPLOYEE_SUCCESS',
  UPDATE_LICENSE_EMPLOYEE_FAILED = 'UPDATE_LICENSE_EMPLOYEE_FAILED',
}

// TYPES

export type TUpdateLicenseEmployeeRequest = {
  type: EUpdateLicenseEmployeeAction.UPDATE_LICENSE_EMPLOYEE_REQUEST;
  payload: {
    materials: TUpdateLicenseEmployeeBody;
    companyId: number;
    employeeId: number;
    successCallback?: (response: TUpdateLicenseEmployeeResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TUpdateLicenseEmployeeSuccess = {
  type: EUpdateLicenseEmployeeAction.UPDATE_LICENSE_EMPLOYEE_SUCCESS;
  payload: { response: TUpdateLicenseEmployeeResponse };
};

export type TUpdateLicenseEmployeeFailed = {
  type: EUpdateLicenseEmployeeAction.UPDATE_LICENSE_EMPLOYEE_FAILED;
};

// FUNCTION

export const updateLicenseEmployeeAction = {
  request: createActionCreator(
    EUpdateLicenseEmployeeAction.UPDATE_LICENSE_EMPLOYEE_REQUEST,
    (resolve) =>
      (
        materials: TUpdateLicenseEmployeeBody,
        companyId: number,
        employeeId: number,
        successCallback?: (response: TUpdateLicenseEmployeeResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TUpdateLicenseEmployeeRequest =>
        resolve({ materials, companyId, employeeId, successCallback, failedCallback }),
  ),
  success: createActionCreator(
    EUpdateLicenseEmployeeAction.UPDATE_LICENSE_EMPLOYEE_SUCCESS,
    (resolve) =>
      (response: TUpdateLicenseEmployeeResponse): TUpdateLicenseEmployeeSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    EUpdateLicenseEmployeeAction.UPDATE_LICENSE_EMPLOYEE_FAILED,
    (resolve) =>
      (error: any): TUpdateLicenseEmployeeFailed =>
        resolve({ error }),
  ),
};
